const PARTIAL_CONTENT = 206 as const;
const FORBIDDEN = 401 as const;
const INTERNAL_SERVER_ERROR = 500 as const;

export const HTTPS_CODE = {
  PARTIAL_CONTENT,
  FORBIDDEN,
  INTERNAL_SERVER_ERROR,
};
